<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>{{ errorMessage }}</div>
        </div>

        <!-- Products List -->
        <table class="table">
            <thead>
                <tr>
                    <th>Methode</th>
                    <th>Product</th>
                    <th>EAN</th>
                    <th>Hoeveelheid</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="vertical-align: middle;">
                        <span *ngFor="let course of orderItem.courses">
                            {{course.title}}
                        </span>
                    </td>
                    <td style="vertical-align: middle;">{{ orderItem.name }}</td>
                    <td style="vertical-align: middle;">{{ orderItem.ean }}</td>
                    <td style="vertical-align: middle;">
                        <input type="number" class="form-control" [(ngModel)]="orderItem.quantity"
                            min="1" placeholder="Qty" />
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Add Selected Products Button -->
        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="updateProduct()">Bestelling bijwerken</button>
        </div>
    </div>
</div>